import {ReactNode} from "react";
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export enum FlintFieldsetLegendStyle {
    Standard = "Standard",
    Big = "Big",
    Small = "Small",
}

const legendSizeClass: Record<FlintFieldsetLegendStyle, string> = {
    [FlintFieldsetLegendStyle.Standard]: "h6",
    [FlintFieldsetLegendStyle.Big]: "h5",
    [FlintFieldsetLegendStyle.Small]: "h7",
};

export default function FlintFieldset(props: FlintFieldsetProps) {
    const baseClass = props.marginBottom ? `vivo-fieldset mb-${props.marginBottom}` : "vivo-fieldset mb-5";
    const className = props.className ? `${baseClass} ${props.className}` : baseClass;

    const sizeClass = legendSizeClass[props.legendStyle ?? FlintFieldsetLegendStyle.Standard];
    const borderClass = props.showLegendBorder ? "border-bottom pb-2" : "";
    const legendClass = ["color-primary", sizeClass, borderClass, props.legendClassName].filter(Boolean).join(" ");

    return (
        <fieldset className={className}>
            {props.legend &&
                <legend className={legendClass}>
                    {props.icon && <FontAwesomeIcon icon={props.icon} className="me-2"/>}
                    {props.legend}
                </legend>
            }
            {props.children}
        </fieldset>
    );
}

export interface FlintFieldsetProps {
    children: ReactNode;
    legend?: string;
    legendStyle?: FlintFieldsetLegendStyle;
    legendClassName?: string;
    icon?: IconDefinition;
    showLegendBorder?: boolean;
    // 0-5, auto (bootstrap notation - just suffix for mb-*)
    marginBottom?: number | "auto";
    className?: string;
}
